<!-- 
  Created by:Upendram Reddy Tanuja
  Created on: 21-Aug-2019 1:00 PM
  Purpose: To set  password Manager
-->
<div class="container">
  <div class="row ">
    <div class="col-md-6 offset-md-3 " style="margin-top: 220px">
      <mat-card class="example-card text-center">

        <form [formGroup]="password_manager_form">
          <div class="row">
            <div class="col-md-12 col-sm-12 pt-1 pb-1">
              <mat-form-field floatLabel="always">
                <mat-label> New Password</mat-label>
                <input type="password" name="password" class="w-93" matInput placeholder="Password"
                  formControlName="password" [required]="true">
              </mat-form-field>
              <mat-form-field floatLabel="always">
                <mat-label>Reenter Password</mat-label>
                <input type="password" name="re_enter_password" class="w-93" matInput placeholder="Password"
                  formControlName="re_enter_password" [required]="true">
              </mat-form-field>
            </div>
          </div>
        </form>
        <div class="row">
          <div class="col-md-12">
            <button [disabled]="password_manager_form.invalid" class="float-right ml-1 btn btn-sm btn-info"
              (click)="save()">
              Submit
            </button>
            <button class="float-right ml-auto btn btn-sm btn-danger" id="myModal" (click)="cancel()">
              Cancel
            </button>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>